module.exports = __webpack_public_path__ + "static/media/ic-time.45f98774.webp";